export default "__VITE_ASSET__M7p7v_$Q__"